const config = {
	API_URL: 'https://dashboarddev.freshtrack.ma/api',
	EXPLORE: 'https://activitydev.freshtrack.ma/api',
};

export default config;
